import * as React from "react"
import { cn } from "../../lib/utils"
import * as LabelPrimitive from "@radix-ui/react-label"

// The template's label (next-shadcn-admin-dashboard/src/components/ui/
// label.tsx at bff60d4), every class unchanged: Helix's `cn` and Radix
// import. Record: docs/testing/ui-migration/061-ui-label.md.

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Label }
